<div class="shop-settings-skeleton">
    <!-- Page Header -->
    <div class="page-header">
        <div class="page-header-left">
            <app-skeleton-rect width="200px" height="28px" class="mb-2 d-block"></app-skeleton-rect>
            <app-skeleton-rect width="300px" height="16px" class="d-block"></app-skeleton-rect>
        </div>
        <div class="page-header-actions">
            <app-skeleton-rect width="140px" height="38px" borderRadius="8px"></app-skeleton-rect>
        </div>
    </div>

    <!-- Settings Cards -->
    <ng-container *ngFor="let i of [0, 1, 2]">
        <div class="settings-card">
            <div class="settings-card-content">
                <!-- Header Row -->
                <div class="settings-header-row">
                    <div class="settings-info">
                        <app-skeleton-rect width="40px" height="40px" borderRadius="8px"
                            class="me-3"></app-skeleton-rect>
                        <app-skeleton-rect width="150px" height="20px"></app-skeleton-rect>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                        <app-skeleton-rect width="70px" height="24px" borderRadius="12px"></app-skeleton-rect>
                        <app-skeleton-rect width="32px" height="32px" borderRadius="6px"></app-skeleton-rect>
                        <app-skeleton-rect width="32px" height="32px" borderRadius="6px"></app-skeleton-rect>
                    </div>
                </div>

                <!-- Body Row -->
                <div class="settings-body-row">
                    <div class="info-grid">
                        <div class="info-item">
                            <app-skeleton-rect width="80px" height="12px" class="mb-1 d-block"></app-skeleton-rect>
                            <app-skeleton-rect width="100px" height="16px" class="d-block"></app-skeleton-rect>
                        </div>
                        <div class="info-item">
                            <app-skeleton-rect width="100px" height="12px" class="mb-1 d-block"></app-skeleton-rect>
                            <app-skeleton-rect width="120px" height="16px" class="d-block"></app-skeleton-rect>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>